export default __webpack_public_path__ + "cockroach-topview-purple.png?f16f814af967822835693021bbc3754d";